import { useCurrentTime } from '@/scenarios/legacy-player/hooks/useCurrentTime';
import { useDuration } from '@/scenarios/legacy-player/hooks/useDuration';

export const useRemainingTime = () => {
    const duration = useDuration();
    const currentTime = useCurrentTime();

    return Math.max(0, duration - currentTime);
};
